import baseRequest from "../_core/baseRequest";

export default {
    upload: params => baseRequest.post("upload", params)
};
